module.exports = __webpack_public_path__ + "img/Flag_of_Liberia.a094a56a.svg";